// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "@babel/polyfill";
import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import DynamicRouting from './router/dynamic-routing'
import API from '@/api'
Vue.prototype.API = API
Vue.use(DynamicRouting, router)

import Util from '@/utils/util'
Vue.prototype.$util = Util

import '@/api'
import '@/assets/css/reset.styl'
import '@/assets/css/comm.styl'
import '@/assets/iconfont/iconfont.css'

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/assets/css/element-override.styl'
Vue.use(ElementUI,  { size: 'small'});

import Moment from 'moment'
Moment.locale('zh-cn');
Vue.prototype.$moment = Moment

import ListPage from '@/components/list-page'
Vue.component('list-page', ListPage)
import DateRange from '@/components/date-range'
Vue.component('date-range', DateRange)

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js